import React, { useState } from 'react';
import { ModalTransition } from '@atlaskit/modal-dialog';
import { ufologger } from '@atlassian/ufo';

import { FlagManager } from '@/components/primitive';
import { Nav } from '@/components/composed';
import DeleteModal from '@/components/composed/modals/delete-modal';
import CreateEntityDrawer from '@/components/composed/create-entity-drawer/create-entity-drawer';
import EditEntityDrawer from '@/components/composed/edit-entity-drawer/edit-entity-drawer';
import Body from '@/views/body';
import { useInitializedAnalytics } from '@/common/ufo';

import Contexts from './contexts';

if (__DEPLOY_ENV__ === 'local' && __UFO_LOGGER_ENABLED__) {
  ufologger.enable();
}

const App: React.FC = () => {
  const [isCreateFormOpen, setIsCreateFormOpen] = useState(false);
  useInitializedAnalytics();
  return (
    <Contexts>
      <Nav onCreate={() => setIsCreateFormOpen(true)} />
      <CreateEntityDrawer isOpen={isCreateFormOpen} setIsOpen={setIsCreateFormOpen} />
      <EditEntityDrawer />
      <Body />
      <FlagManager />
      <ModalTransition>
        <DeleteModal />
      </ModalTransition>
    </Contexts>
  );
};

export default App;
